import { get, create, update, remove } from "@/utill/getData";

export function getMenuList() {
  return get("/menus");
}

export function addMenu(param) {
  return create("/menus", param);
}

export function updateMenu(param) {
  return update(`/menus/${param.menuId}`, param);
}

export function removeMenu(menuId) {
  return remove(`/menus/${menuId}`);
}
